import { Box, Button, Chip, Collapse, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateAlarmStatus } from "../../../application/actions/uiActions";
import { toJalaliFullDate } from "../../middleware/middleware";

import GppBadIcon from "@mui/icons-material/GppBad";
import GppGoodIcon from "@mui/icons-material/GppGood";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";

const AlarmItem = ({ alarm }) => {
  const dispatch = useDispatch();
  const [isLongText, setIsLongText] = useState(false);
  const [showFullText, setShowFullText] = useState(false);

  useEffect(() => {
    if (alarm.alarmDetails && alarm.alarmDetails.length > 40) {
      setIsLongText(true);
      setShowFullText(false);
    } else {
      setIsLongText(false);
    }
  }, [alarm.alarmDetails]);

  const onShowAlarmDetail = () => {
    if (!showFullText && alarm.alarmStatus === "NotSeen") {
      dispatch(updateAlarmStatus(alarm.id));
    }
    setShowFullText((old) => !old);
  };

  return (
    <Grid
      item
      xs={12}
      container
      spacing={1}
      sx={{ borderBottom: "1px solid", borderColor: "divider", mb: 2, pb: 1 }}
    >
      <Grid item xs={12}>
        <Box sx={{ display: "inline-flex", gap: 1, alignItems: "center" }}>
          {alarm.importance === "Dangerous" ? (
            <GppBadIcon color="danger" />
          ) : alarm.importance === "Warning" ? (
            <GppMaybeIcon color="warning" />
          ) : (
            <GppGoodIcon color="success" />
          )}
          <Typography variant="body1" fontWeight={600}>
            {alarm.title}
          </Typography>

          {alarm.alarmStatus === "NotSeen" ? (
            <Chip
              label="جدید"
              color="warning"
              variant="outlined"
              size="small"
              sx={{
                height: "auto",
                "& .MuiChip-label": {
                  display: "block",
                  whiteSpace: "normal",
                },
              }}
            />
          ) : null}
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body2" textAlign={"justify"}>
          {isLongText ? (
            <>
              <Collapse in={!showFullText}>
                {alarm.alarmDetails.substr(0, 40) + "..."}
              </Collapse>

              <Collapse in={!!showFullText}>{alarm.alarmDetails}</Collapse>

              <Button variant="text" size="small" onClick={onShowAlarmDetail}>
                {showFullText ? "مشاهده کمتر" : "مشاهده بیشتر"}
              </Button>
            </>
          ) : (
            alarm.alarmDetails
          )}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography
          variant="body2"
          color={"text.secondary"}
          textAlign={"right"}
        >
          {toJalaliFullDate(alarm.updateOn)}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default AlarmItem;
